import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  paymentMethod: string;
  brand: string;
  hasError: boolean;
  creditCardForm: string;
  showBlacklist: boolean;
  subscriptionStep: string;
  errorDescription: string;
  errorType: string;
  pix?: {
    qrCodeUrl: string;
    pixCode: string;
    pixExpirationTime: number;
    isExpired?: boolean;
    isAutoPix?: boolean;
  },
  chargeId?: string;
  cardLastDigits?: string;
  showAutoPix: boolean;
}


const initialState: State = {
  paymentMethod: null,
  brand: null,
  hasError: false,
  errorDescription: null,
  errorType: null,
  creditCardForm: 'billing',
  showBlacklist: false,
  subscriptionStep: '',
  pix: {
    qrCodeUrl: '',
    pixCode: '',
    pixExpirationTime: 10,
    isExpired: false,
  },
  chargeId: null,
  showAutoPix: false,
}

interface SetPixDataPayload {
  qrCodeUrl: string;
  pixCode: string;
  pixExpirationTime: number;
  isAutoPix?: boolean;
}

const payment = createSlice({
  name: 'payment',

  initialState,

  reducers: {
    setPaymentMethod(state, action: PayloadAction<any>) {
      state.paymentMethod = action.payload.paymentMethod;
      if (action.payload?.brand !== undefined)  {
        state.brand = action.payload.brand;
      }
    },

    setPaymentBrand(state, action: PayloadAction<any>) {
      state.brand = action.payload.brand;
    },

    setSubscriptionError(state, action: PayloadAction<any>) {
      state.hasError = action.payload.hasError;
      state.errorDescription = action.payload.errorDescription || null;
      state.errorType = action.payload.errorType || null;
    },

    setCreditCardForm(state, action: PayloadAction<string>) {
      state.creditCardForm = action.payload;
    },

    setShowBlacklist(state, action: PayloadAction<boolean>) {
      state.showBlacklist = action.payload;
    },

    setSubscriptionStep(state, action: PayloadAction<any>) {
      state.subscriptionStep = action.payload.subscriptionStep;
    },

    setPixData(state, action: PayloadAction<SetPixDataPayload>) {
      state.pix.qrCodeUrl = action.payload.qrCodeUrl;
      state.pix.pixCode = action.payload.pixCode;
      state.pix.pixExpirationTime = action.payload.pixExpirationTime;
      state.pix.isAutoPix = action.payload.isAutoPix || false;
    },

    setChargeId(state, action: PayloadAction<string>) {
      state.chargeId = action.payload;
    },

    setPixExpired(state, action: PayloadAction<boolean>) {
      state.pix.isExpired = action.payload;
    },

    setCardLastDigits(state, action: PayloadAction<string>) {
      state.cardLastDigits = action.payload;
    },

    setShowAutoPix(state, action: PayloadAction<boolean>) {
      state.showAutoPix = action.payload;
    }
  },
});

export const {
  setPaymentMethod,
  setPaymentBrand,
  setSubscriptionError,
  setCreditCardForm,
  setShowBlacklist,
  setSubscriptionStep,
  setPixData,
  setChargeId,
  setPixExpired,
  setCardLastDigits,
  setShowAutoPix,
} = payment.actions;


export default payment.reducer;
